import { ChangeDetectionStrategy, Component, computed, model, OnInit } from "@angular/core";
import { FormControl, ReactiveFormsModule, Validators } from "@angular/forms";

import { InputComponent } from "@shared/components/input/input.component";
import { BaseModalComponent } from "@shared/components/modal/base-modal.component";
import { ModalComponent } from "@shared/components/modal/modal.component";

@Component({
  selector: "component-prompt-modal",
  templateUrl: "./prompt-modal.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, ModalComponent, InputComponent]
})
export class PromptModalComponent extends BaseModalComponent implements OnInit {
  readonly currentValue = model<string>("");
  readonly title = model<string>("Enter value");
  readonly label = model<string>("Value");
  readonly confirmButtonText = model<string>("Ok");
  readonly required = model<boolean>(true);

  protected readonly errorMessage = computed(() => this.errorMessageComputation());

  protected control: FormControl<string> = new FormControl("", { nonNullable: true });

  ngOnInit(): void {
    this.control.setValue(this.currentValue());

    if (this.required()) {
      this.control.addValidators(Validators.required);
    }
  }

  protected onSave(): void {
    if (this.control.valid) {
      this.activeModal.close(this.control.value);
    }
  }

  private errorMessageComputation(): string {
    const label = this.label();
    if (!label || label.length === 0) return "Field is required";

    const formattedLabel = label[0] + label.slice(1).toLowerCase();
    return `${formattedLabel} is required`;
  }
}
